import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import { CheckBox } from "components/support";
import { colors } from "assets";

class PermissionsFieldsView extends Component {
  constructor(props) {
    super(props);
    this.presenter = props.presenter;
  }

  componentWillReceiveProps(nextProps) {
    this.props.viewModel.mode = nextProps.mode;
    if (
      !!nextProps.currentUser.permissions &&
      nextProps.currentUser.permissions.length > 0
    ) {
      const formPermissions = !!nextProps.form.permissions
        ? nextProps.form.permissions
        : "";
      this.presenter.onComponentReady(
        nextProps.currentUser.permissions,
        formPermissions
      );
    }
  }

  handleCheck = (field, value) => {
    const permissionValue = this.presenter.onCheck(field, value);
    this.props.onChange(permissionValue, "permissions");

    if (permissionValue.length > 0) {
      this.props.setFieldError("permissions", "");
    }
  };

  render() {
    return (
      <Row>
        <Col xs={12}>
          <div style={{ marginTop: -8 }}>
            <h4
              style={{
                backgroundColor: colors.permissionFields.dark,
                color: "#FFF",
                borderRadius: 5,
                padding: 5,
                textAlign: "center",
                textTransform: "uppercase"
              }}
            >
              Permissões de Acesso
            </h4>
            {this.props.errors.permissions !== "" && (
              <h5 style={{ color: "red", textAlign: "center" }}>
                {this.props.errors.permissions}
              </h5>
            )}
          </div>
        </Col>
        {this.props.viewModel.permissions.length === 0 && (
          <p>Não há permissões de acesso para este usuário.</p>
        )}
        {this.props.viewModel.permissions.map((permission, index) => (
          <Col key={index} xs={12} md={6} lg={4}>
            <CheckBox
              checked={permission.value}
              label={permission.field}
              style={{ marginTop: "10px", marginLeft: "10px" }}
              onCheck={value => this.handleCheck(permission.field, value)}
            />
          </Col>
        ))}
      </Row>
    );
  }
}

export default PermissionsFieldsView;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/permissions-fields/permissions-fields.view.js